function contents() {

    return {
        'session_changed'  : 'The session has been changed. Do you want to refresh this page?'
    };

}

export default contents;